const ToolbarButtonContainer = ( props ) => (
	<div className={ props.className }>{ props.children }</div>
);
export default ToolbarButtonContainer;
